export const statesJson = [
  {
    state: "Andhra Pradesh",
  },
  {
    state: "Arunachal Pradesh",
  },
  {
    state: "Assam",
  },
  {
    state: "Bihar",
  },
  {
    state: "Chandigarh (UT)",
  },
  {
    state: "Chhattisgarh",
  },
  {
    state: "Dadra and Nagar Haveli (UT)",
  },
  {
    state: "Daman and Diu (UT)",
  },
  {
    state: "Delhi (NCT)",
  },
  {
    state: "Goa",
  },
  {
    state: "Gujarat",
  },
  {
    state: "Haryana",
  },
  {
    state: "Himachal Pradesh",
  },
  {
    state: "Jammu and Kashmir",
  },
  {
    state: "Jharkhand",
  },
  {
    state: "Karnataka",
  },
  {
    state: "Kerala",
  },
  {
    state: "Lakshadweep (UT)",
  },
  {
    state: "Madhya Pradesh",
  },
  {
    state: "Maharashtra",
  },
  {
    state: "Manipur",
  },
  {
    state: "Meghalaya",
  },
  {
    state: "Mizoram",
  },
  {
    state: "Nagaland",
  },
  {
    state: "Odisha",
  },
  {
    state: "Puducherry (UT)",
  },
  {
    state: "Punjab",
  },
  {
    state: "Rajasthan",
  },
  {
    state: "Sikkim",
  },
  {
    state: "Tamil Nadu",
  },
  {
    state: "Telangana",
  },
  {
    state: "Tripura",
  },
  {
    state: "Uttarakhand",
  },
  {
    state: "Uttar Pradesh",
  },
  {
    state: "West Bengal",
  },
];

export const stateList = [
  {
    id: 1638,
    name: "Andaman and Nicobar Islands",
    stateId: "4023",
    stateCode: "AN",
    kraStateCode: "035",
    createdAt: "2024-09-01T02:56:16.838108Z",
    country: 102,
  },
  {
    id: 1639,
    name: "Andhra Pradesh",
    stateId: "4017",
    stateCode: "AP",
    kraStateCode: "028",
    createdAt: "2024-09-01T02:56:16.838120Z",
    country: 102,
  },
  {
    id: 1641,
    name: "Assam",
    stateId: "4027",
    stateCode: "AS",
    kraStateCode: "013",
    createdAt: "2024-09-01T02:56:16.838143Z",
    country: 102,
  },
  {
    id: 1642,
    name: "Bihar",
    stateId: "4037",
    stateCode: "BR",
    kraStateCode: "010",
    createdAt: "2024-09-01T02:56:16.838154Z",
    country: 102,
  },
  {
    id: 1643,
    name: "Chandigarh",
    stateId: "4031",
    stateCode: "CH",
    kraStateCode: "004",
    createdAt: "2024-09-01T02:56:16.838166Z",
    country: 102,
  },
  {
    id: 1644,
    name: "Chhattisgarh",
    stateId: "4040",
    stateCode: "CT",
    kraStateCode: "022",
    createdAt: "2024-09-01T02:56:16.838177Z",
    country: 102,
  },
  {
    id: 1645,
    name: "Dadra and Nagar Haveli and Daman and Diu",
    stateId: "4033",
    stateCode: "DH",
    kraStateCode: "",
    createdAt: "2024-09-01T02:56:16.838188Z",
    country: 102,
  },
  {
    id: 1646,
    name: "Delhi",
    stateId: "4021",
    stateCode: "DL",
    kraStateCode: "007",
    createdAt: "2024-09-01T02:56:16.838199Z",
    country: 102,
  },
  {
    id: 1647,
    name: "Goa",
    stateId: "4009",
    stateCode: "GA",
    kraStateCode: "030",
    createdAt: "2024-09-01T02:56:16.838211Z",
    country: 102,
  },
  {
    id: 1648,
    name: "Gujarat",
    stateId: "4030",
    stateCode: "GJ",
    kraStateCode: "024",
    createdAt: "2024-09-01T02:56:16.838222Z",
    country: 102,
  },
  {
    id: 1650,
    name: "Himachal Pradesh",
    stateId: "4020",
    stateCode: "HP",
    kraStateCode: "002",
    createdAt: "2024-09-01T02:56:16.838245Z",
    country: 102,
  },
  {
    id: 1651,
    name: "Jammu and Kashmir",
    stateId: "4029",
    stateCode: "JK",
    kraStateCode: "001",
    createdAt: "2024-09-01T02:56:16.838256Z",
    country: 102,
  },
  {
    id: 1652,
    name: "Jharkhand",
    stateId: "4025",
    stateCode: "JH",
    kraStateCode: "020",
    createdAt: "2024-09-01T02:56:16.838268Z",
    country: 102,
  },
  {
    id: 1653,
    name: "Karnataka",
    stateId: "4026",
    stateCode: "KA",
    kraStateCode: "029",
    createdAt: "2024-09-01T02:56:16.838279Z",
    country: 102,
  },
  {
    id: 1654,
    name: "Kerala",
    stateId: "4028",
    stateCode: "KL",
    kraStateCode: "032",
    createdAt: "2024-09-01T02:56:16.838290Z",
    country: 102,
  },
  {
    id: 1656,
    name: "Lakshadweep",
    stateId: "4019",
    stateCode: "LD",
    kraStateCode: "031",
    createdAt: "2024-09-01T02:56:16.838313Z",
    country: 102,
  },
  {
    id: 1657,
    name: "Madhya Pradesh",
    stateId: "4039",
    stateCode: "MP",
    kraStateCode: "023",
    createdAt: "2024-09-01T02:56:16.838324Z",
    country: 102,
  },
  {
    id: 1658,
    name: "Maharashtra",
    stateId: "4008",
    stateCode: "MH",
    kraStateCode: "027",
    createdAt: "2024-09-01T02:56:16.838336Z",
    country: 102,
  },
  {
    id: 1659,
    name: "Manipur",
    stateId: "4010",
    stateCode: "MN",
    kraStateCode: "014",
    createdAt: "2024-09-01T02:56:16.838347Z",
    country: 102,
  },
  {
    id: 1660,
    name: "Meghalaya",
    stateId: "4006",
    stateCode: "ML",
    kraStateCode: "017",
    createdAt: "2024-09-01T02:56:16.838359Z",
    country: 102,
  },
  {
    id: 1661,
    name: "Mizoram",
    stateId: "4036",
    stateCode: "MZ",
    kraStateCode: "015",
    createdAt: "2024-09-01T02:56:16.838371Z",
    country: 102,
  },
  {
    id: 1663,
    name: "Odisha",
    stateId: "4013",
    stateCode: "OR",
    kraStateCode: "",
    createdAt: "2024-09-01T02:56:16.838397Z",
    country: 102,
  },
  {
    id: 1664,
    name: "Puducherry",
    stateId: "4011",
    stateCode: "PY",
    kraStateCode: "034",
    createdAt: "2024-09-01T02:56:16.838410Z",
    country: 102,
  },
  {
    id: 1665,
    name: "Punjab",
    stateId: "4015",
    stateCode: "PB",
    kraStateCode: "003",
    createdAt: "2024-09-01T02:56:16.838421Z",
    country: 102,
  },
  {
    id: 1666,
    name: "Rajasthan",
    stateId: "4014",
    stateCode: "RJ",
    kraStateCode: "008",
    createdAt: "2024-09-01T02:56:16.838432Z",
    country: 102,
  },
  {
    id: 1667,
    name: "Sikkim",
    stateId: "4034",
    stateCode: "SK",
    kraStateCode: "011",
    createdAt: "2024-09-01T02:56:16.838444Z",
    country: 102,
  },
  {
    id: 1669,
    name: "Telangana",
    stateId: "4012",
    stateCode: "TG",
    kraStateCode: "037",
    createdAt: "2024-09-01T02:56:16.838467Z",
    country: 102,
  },
  {
    id: 1670,
    name: "Tripura",
    stateId: "4038",
    stateCode: "TR",
    kraStateCode: "016",
    createdAt: "2024-09-01T02:56:16.838481Z",
    country: 102,
  },
  {
    id: 1671,
    name: "Uttar Pradesh",
    stateId: "4022",
    stateCode: "UP",
    kraStateCode: "009",
    createdAt: "2024-09-01T02:56:16.838492Z",
    country: 102,
  },
  {
    id: 1672,
    name: "Uttarakhand",
    stateId: "4016",
    stateCode: "UK",
    kraStateCode: "005",
    createdAt: "2024-09-01T02:56:16.838503Z",
    country: 102,
  },
  {
    id: 1673,
    name: "West Bengal",
    stateId: "4853",
    stateCode: "WB",
    kraStateCode: "019",
    createdAt: "2024-09-01T02:56:16.838515Z",
    country: 102,
  },
  {
    id: 1640,
    name: "Arunachal Pradesh",
    stateId: "4024",
    stateCode: "AR",
    kraStateCode: "012",
    createdAt: "2024-09-01T02:56:16.838132Z",
    country: 102,
  },
  {
    id: 1649,
    name: "Haryana",
    stateId: "4007",
    stateCode: "HR",
    kraStateCode: "006",
    createdAt: "2024-09-01T02:56:16.838234Z",
    country: 102,
  },
  {
    id: 1655,
    name: "Ladakh",
    stateId: "4852",
    stateCode: "LA",
    kraStateCode: "038",
    createdAt: "2024-09-01T02:56:16.838302Z",
    country: 102,
  },
  {
    id: 1662,
    name: "Nagaland",
    stateId: "4018",
    stateCode: "NL",
    kraStateCode: "018",
    createdAt: "2024-09-01T02:56:16.838383Z",
    country: 102,
  },
  {
    id: 1668,
    name: "Tamil Nadu",
    stateId: "4035",
    stateCode: "TN",
    kraStateCode: "033",
    createdAt: "2024-09-01T02:56:16.838455Z",
    country: 102,
  },
];
